import React from "react";

const FileIcon = ({ color = "#0C9227" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 1H2V15H14V5L10 1Z"
        fill={`${color}b3`}
      />
      <path d="M10 1L14 5H10V1Z" fill={color} />
    </svg>
  );
};

export default FileIcon;
